<template>
    <v-content>
        <v-img
            :src="require(`@/assets/img/godfather/bg-${country}.jpg`)"
            height="60vh"
            style="min-height: 300px;"
            cover
        >
            <v-layout row>
                <v-flex xs12>
                    <img
                        :src="require(`@/assets/img/logo.png`)"
                        height="60px%"
                        style="margin: 0 auto;display: block;"
                        class="mt-5"
                    />
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12 text-xs-center>
                    <h1
                        class="display-2 white--text mt-5"
                        v-html="$t('godFatherTitle')"
                    ></h1>
                </v-flex>
            </v-layout>
        </v-img>
        <v-container>
            <v-layout row>
                <v-flex xs12>
                    <v-list class="mt-4">
                        <v-list-tile>
                            <v-list-tile-avatar>
                                <img src="/static/img/godfather-step-1.png" />
                            </v-list-tile-avatar>
                            <v-list-tile-title
                                v-html="$t('godFatherSteps1')"
                            ></v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile class="mt-3">
                            <v-list-tile-avatar>
                                <img src="/static/img/godfather-step-2.png" />
                            </v-list-tile-avatar>
                            <v-list-tile-title
                                v-html="$t('godFatherSteps2')"
                            ></v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-layout>

            <v-layout row class="mt-5">
                <v-flex xs12 sm12 text-xs-center>
                    <h2
                        class="citySelector primary--text"
                        v-html="$t('choose.a.city.text')"
                    ></h2>
                </v-flex>
            </v-layout>

            <v-layout row wrap justify-space-around>
                <template v-for="(city, index) in this.cities">
                    <v-flex :key="index" xs12 sm12 md5>
                        <v-btn
                            class="primary"
                            block
                            v-html="city.name"
                            :href="getLink(city)"
                        >
                        </v-btn>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
        <wsp-footer></wsp-footer>
    </v-content>
</template>

<script>
import WspFooter from '@/components/WspFooter';
import store from '@/store';
import _ from 'lodash';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
    name: 'godfather',

    components: {
        [WspFooter.name]: WspFooter
    },

    metaInfo() {
        return {
            title: this.$i18n.t('page.godfather.title'),
            meta: [
                {
                    name: 'description',
                    content: this.$i18n.t('page.description')
                },
                {
                    name: 'keywords',
                    content: this.$i18n.t('page.keywords')
                },
                {
                    property: 'twitter:title',
                    content: this.$i18n.t('meta.godfather.twitter.title')
                },
                {
                    property: 'twitter:card',
                    content: 'photo'
                },
                {
                    property: 'twitter:site',
                    content: '@wesmartpark'
                },
                {
                    property: 'twitter:image',
                    content:
                        'https://www-corp.wesmartpark.com/static/img/share/godfather.jpg'
                },
                {
                    property: 'twitter:url',
                    content: window.location.href
                },
                {
                    property: 'og:title',
                    content: this.$i18n.t('meta.godfather.og.title')
                },
                {
                    property: 'og:url',
                    content: window.location.href
                    // content: 'https://smarturl.it/wsp-app'
                },
                {
                    property: 'og:site_name',
                    content: 'wesmartPark'
                },
                {
                    property: 'og:type',
                    content: 'website'
                },
                {
                    property: 'og:description',
                    content: this.$i18n.t('meta.godfather.og.description')
                },
                {
                    property: 'og:image',
                    content:
                        'https://www-corp.wesmartpark.com/static/img/share/godfather.jpg'
                },
                {
                    property: 'og:image:alt',
                    content: this.$i18n.t('meta.godfather.og.image')
                },
                {
                    property: 'og:image:width',
                    content: '1200'
                },
                {
                    property: 'og:image:height',
                    content: '586'
                },
                {
                    property: 'og:image:type',
                    content: 'image/jpeg'
                }
            ]
        };
    },

    computed: {
        cities() {
            let country = store.state.country;
            let t = _.filter(store.state.cities, function(obj) {
                return obj.country === country;
            });
            return t;
        }
    },

    data() {
        return {
            godfather: this.$route.query.godfather,
            country: store.state.country.toLowerCase()
        };
    },
    mounted() {
        EventBus.$emit(keys.countrySelected, {});
    },
    methods: {
        getLink(city) {
            return `${city.urlCity}/${this.country}/${this.$i18n.t(
                'godfather.url.register'
            )}?godfather=${this.godfather}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.citySelector {
    margin-bottom: 1vh;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Godfather.vue